import { Injectable } from '@angular/core';

import { Subject } from 'rxjs';
import { pluck } from 'rxjs/operators';

interface UndoState {
  isUndo: boolean;
}

@Injectable()
export class UndoService {

  private readonly undoState$ = new Subject<UndoState>();

  get undoStateStream$() {
    return this.undoState$.asObservable();
  }

  constructor() { }

  selectIsUndoState() {
    return this.undoStateStream$.pipe(pluck('isUndo'));
  }

  setIsUndo(isUndo: boolean) {
    this.undoState$.next({
      isUndo,
    });
  }
}
